import { render, staticRenderFns } from "./RotateSquare4.vue?vue&type=template&id=8f22e326&scoped=true&"
import script from "./RotateSquare4.vue?vue&type=script&lang=js&"
export * from "./RotateSquare4.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare4.vue?vue&type=style&index=0&id=8f22e326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22e326",
  null
  
)

export default component.exports